var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0V19H0V3L3 0H24ZM3 3H6V6H3V3ZM8 3H11V6H8V3ZM16 3H13V6H16V3ZM18 3H21V6H18V3ZM3 8H6V11H3V8ZM8 8H11V11H8V8ZM16 8H13V11H16V8ZM18 8H21V11H18V8ZM6 13H3V16H6V13ZM11 13H8V16H11V13ZM13 13H16V16H13V13ZM21 13H18V16H21V13Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/Plate.7fc31654a8d8c850382508568b1f7d6f.svg";
export { ForwardRef as ReactComponent };